// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"a5339032","357":"4a556a50","615":"4a556a50","881":"4a556a50","964":"4a556a50"}[chunkId] + ".chunk.css";
};